<div class="row" style="justify-content: center">
  <h1 class="text-center" mat-dialog-title>Observaciones</h1>
</div>
<div class="containerModal">
  <form [formGroup]="Observaciones" mat-dialog-content>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="form-group">
          <textarea
            class="form-control"
            formControlName="obs"
            rows="8"
          ></textarea>
        </div>
        <div class="row">
          <div class="col-6">
            <label>Enviar copia de los correos automáticos a:</label>
            <div class="input-group" *ngIf="addEmail">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="correo"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Correo"
              />
              <div class="input-group-append" style="height: 100%">
                <button class="input-group-text" (click)="addToCorreoToList()" *ngIf="addEmail">
                  <mat-icon style="cursor: pointer">add</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div
            class="col-6"
            style="
              overflow-y: auto;
              height: 85px !important;
              overflow-x: hidden;
            "
          >
            <div class="row" *ngFor="let correo of correos; let i = index">
              <div class="col-10 email-container">
                <label title="{{ correo }}">{{ correo }}</label>
              </div>
              <div class="col-1">
                <mat-icon (click)="removeFromList(i)" style="cursor: pointer"
                  >delete_forever</mat-icon>
              </div>
            </div>
          </div>
        </div>

        <p id="texto">
          Se enviara los siguientes documentos para el proceso de firma
        </p>
        <p *ngIf="aviso">{{ aviso }}</p>
        <div class="form-check" id="mandato">
          <input
            class="form-check-input"
            type="checkbox"
            formControlName="mandato"
            id="flexCheckDefault"
          />
          <label class="form-check-label" for="flexCheckDefault">Mandato</label>
        </div>
        <div class="form-check" id="poder">
          <input
            class="form-check-input"
            type="checkbox"
            formControlName="poder"
            id="flexCheckChecked"
          />
          <label class="form-check-label" for="flexCheckChecked"
            >Documento de representación</label
          >
        </div>
        <div class="form-check" id="contrato">
          <input
            class="form-check-input"
            type="checkbox"
            formControlName="contrato"
            id="flexCheckChecked3"
          />
          <label class="form-check-label" for="flexCheckChecked3"
            >Contrato de Compra Venta</label
          >
        </div>
      </div>
    </div>
  </form>
  <div mat-dialog-actions class="justify-content-center">
    <div class="col-6">
      <button mat-button class="btn-block btn-secondary" (click)="onNoClick()">
        Cancelar
      </button>
    </div>
    <div class="col-6">
      <button mat-button class="btn-block btn-primary" (click)="Guardar()">
        Aceptar
      </button>
    </div>
  </div>
</div>
